import { AwsRum } from "aws-rum-web";

try {
  new AwsRum(
    "bce88a2c-e6cf-4805-aaaf-ab6dbc390064",
    "1.0.0",
    "eu-central-1",
    {
      sessionSampleRate: 1,
      identityPoolId: "eu-central-1:106205e6-13bb-4b6c-814d-d2853c677f63",
      endpoint: "https://dataplane.rum.eu-central-1.amazonaws.com",
      telemetries: ["performance", "errors", "http"],
      allowCookies: true,
      enableXRay: true,
      signing: true,
    }
  );
} catch (error) {
  console.warn(error);
}
